module.exports = __webpack_public_path__ + "img/snacking.b68feb18.png";